module.exports = __webpack_public_path__ + "img/logo-DISE-tmp.1952864a.svg";